/*
 * @Description: 头条自动提交代码
 * @Author: zhanghao@fang.com
 * @Date: 2020-12-08 13:47:11
 * @LastEditors: zhanghao@fang.com
 */
define('common/ttpush',[], function(require) {
    (function() {
        const script = document.createElement('script'); script.type = 'text/javascript'; script.async = true;
        script.src = 'https://s3a.pstatp.com/toutiao/push.js?7024b321d4f65a1bc46c80768f29172ce2b6c091737a17906ec3d474e54df9b89cb89eb6f8bd10d040e2a1cbef316ba0127feb1c8d3dd8c580c6e3872272a2f9';
        const s = document.getElementsByTagName('head')[0]; s.appendChild(script);
    })();
    
});
